/* 横スクロールできる表（はみ出している table-wrap）にだけ「スクロール可→」を表示する */
(function () {
  function updateScrollHints() {
    document.querySelectorAll('.table-wrap').forEach(function (el) {
      var outer = el.closest('.table-wrap-outer');
      if (outer) {
        outer.classList.toggle('is-scrollable', el.scrollWidth > el.clientWidth + 1);
      }
    });
  }
  document.addEventListener('DOMContentLoaded', updateScrollHints);
  window.addEventListener('load', updateScrollHints);
  window.addEventListener('resize', updateScrollHints);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(updateScrollHints);
    document.querySelectorAll('.table-wrap').forEach(function (el) { ro.observe(el); });
  }
})();

/* class="auto-loop" の動画を、画面内に入った時だけ自動ループ再生する（GIF風）。
   記事HTML側は preload="none" かつ autoplay 属性なしで置いてあるため、
   ここが動かない限り読み込みも再生も始まらない。 */
(function () {
  function prefers(query) {
    return window.matchMedia ? matchMedia(query).matches : false;
  }

  function init() {
    var videos = document.querySelectorAll('video.auto-loop');
    if (!videos.length) return;

    var conn = navigator.connection || {};

    /* 省データモード・低速回線・動きを控える設定では自動再生しない */
    var thrifty =
      conn.saveData === true ||
      /^(slow-2g|2g|3g)$/.test(conn.effectiveType || '') ||
      prefers('(prefers-reduced-motion: reduce)');

    function showControls() {
      videos.forEach(function (video) { video.controls = true; });
    }

    /* マウス環境ではネイティブコントロールに黒いティントがかからないので、
       全画面・シークを使えるよう出しておく。iOSは再生中に動画全体が暗くなる
       ため出さない。自動再生しない場合は再生手段が無くなるので環境を問わず出す。
       preload="none" なので、押されるまで通信は発生しない。 */
    if (thrifty || prefers('(hover: hover) and (pointer: fine)')) showControls();
    if (thrifty) return;

    /* IntersectionObserver が無い環境はコントロールだけで運用する。
       全部を一斉に自動再生させるより、読者に委ねたほうが軽い。 */
    if (!('IntersectionObserver' in window)) {
      showControls();
      return;
    }

    /* iOSは同時にデコードできる動画数に上限があり、超えた分は再生に失敗して
       黒い箱のまま残る。画面内のものだけに絞って上限に触れないようにする。 */
    var MAX_PLAYING = 3;
    var playing = [];
    var onScreen = new Set();

    /* preload="none" のままだと再生指示まで1バイトも落ちてこない。
       読み込みを始めたい時点でこれを呼ぶ。 */
    function buffer(video) {
      if (video.preload === 'auto') return;
      video.preload = 'auto';
      video.load();
    }

    function play(video) {
      buffer(video);
      video.muted = true;
      if (playing.indexOf(video) === -1) playing.push(video);
      while (playing.length > MAX_PLAYING) pause(playing.shift());
      var started = video.play();
      if (started && started.catch) started.catch(function () {});
    }

    function pause(video) {
      if (!video) return;
      video.pause();
      var i = playing.indexOf(video);
      if (i > -1) playing.splice(i, 1);
    }

    /* 画面の手前600pxで読み込みを始めておき、到達時には再生済みの状態にする */
    var preloader = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          buffer(entry.target);
          preloader.unobserve(entry.target);
        });
      },
      { rootMargin: '600px 0px' }
    );

    /* 画面内に十分入ったものだけ再生し、外れたら止める */
    var player = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            onScreen.add(entry.target);
            play(entry.target);
          } else {
            onScreen.delete(entry.target);
            pause(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );

    videos.forEach(function (video) {
      preloader.observe(video);
      player.observe(video);
    });

    /* 裏に回ったタブで再生を続けない。戻ってきたら画面内のものを再開する。
       交差状態は変わっていないので、監視は何も通知してくれない。 */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) playing.slice().forEach(pause);
      else onScreen.forEach(play);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
